import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  alternativeLabels: hasMany('label', { inverse: null }),
  artistFunctions: hasMany('artist-function-relation', { inverse: 'artist' }),
  assetId: belongsTo('asset', { inverse: null }),
  assetIdEyecatcher: belongsTo('asset', { inverse: null }),
  assetIdImage: belongsTo('asset', { inverse: null }),
  seoImage: belongsTo('asset', { inverse: null }),
  categories: hasMany('category', { inverse: null }),
  channels: hasMany('channel', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  collections: hasMany('collection', { inverse: null }),
  contactPeople: hasMany('person', { inverse: null }),
  divisions: hasMany('division', { inverse: null }),
  externalReferences: hasMany('external-reference', { inverse: 'artist' }),
  firstChannel: belongsTo('channel', { inverse: null }),
  labels: hasMany('label', { inverse: null }),
  newsletterConfigs: hasMany('newsletter-config', { inverse: 'artist' }),
  ownedByChannel: belongsTo('channel', { inverse: null }),
  products: hasMany('product', { inverse: null }),
  promotionImage: belongsTo('asset', { inverse: null }),
  similarArtists: hasMany('artist', { inverse: null }),
  stories: hasMany('story', { inverse: null }),
  taxa: hasMany('taxon', { inverse: null }),
  urlAliases: hasMany('url-alias', { inverse: null }),
});
